function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import Button from '@engine/components/presentational/base/button';
import React from 'react';
import { connect } from 'react-redux';
import { requestExport } from '@engine/actions/creators/export-toolbar';

var ExportToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(ExportToolbar, _React$Component);

  var _super = _createSuper(ExportToolbar);

  function ExportToolbar(props) {
    var _this;

    _classCallCheck(this, ExportToolbar);

    _this = _super.call(this, props);

    _this.toggleDropdown = function () {
      _this.setState({
        dropdownOpen: !_this.state.dropdownOpen
      });
    };

    _this.exportFile = function (path) {
      var url = path + '&' + _this.getSearchParams(_this.props.searchForm);

      _this.props.requestExport(url);
    };

    _this.getSearchParams = function (searchForm) {
      var myForm = document.getElementById(searchForm);
      var formData = new FormData(myForm);
      return new URLSearchParams(formData).toString();
    };

    _this.buttonTitles = {
      csv_path: I18n.t('actions.default.export_to_csv'),
      xls_path: I18n.t('actions.default.export_to_excel')
    };
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }

  _createClass(ExportToolbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var exports = this.props.exports;
      return React.createElement("div", {
        className: "dropdown".concat(this.state.dropdownOpen ? ' open' : '')
      }, React.createElement(Button, {
        icon: "download-alt",
        className: "btn btn-xs btn-default btn-block dropdown-toggle",
        id: "dropdown-export",
        onClick: function onClick() {
          return _this2.toggleDropdown();
        }
      }, React.createElement("span", {
        className: "hidden-xs"
      }, I18n.t('shared.actions.default.export_files'), "\xA0"), React.createElement("span", {
        className: "caret"
      })), React.createElement("ul", {
        className: "dropdown-menu dropdown-menu-right",
        "aria-labelledby": "dropdown-export"
      }, Object.keys(exports).map(function (exportPath) {
        return React.createElement("li", {
          key: exportPath
        }, React.createElement(Button, {
          icon: "download-alt",
          className: "btn-dropdown-link",
          onClick: function onClick() {
            return _this2.exportFile(exports[exportPath]);
          }
        }, _this2.buttonTitles[exportPath]));
      })));
    }
  }]);

  return ExportToolbar;
}(React.Component);

export default connect(null, {
  requestExport: requestExport
})(ExportToolbar);